import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Mail } from 'lucide-react';
import { useTheme } from '../../core/contexts/ThemeContext';
export function ContactApp() {
  const {
    theme,
    t
  } = useTheme();
  const isLightTheme = theme === 'light';
  return <div className="h-full overflow-y-auto p-5 md:p-16 pb-28" data-id="element-18">
      <div className="flex flex-col justify-center min-h-full" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 28
      }} className="max-w-2xl mx-auto w-full space-y-12 md:space-y-16" data-id="element-20">
          <div className="space-y-5" data-id="element-21">
            <h1 className={`text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight ${isLightTheme ? 'text-[#1A1A1A]' : 'text-[#E8E8E6]'}`} data-id="element-22">
              {t('contact.heading')}
            </h1>
            <p className={`text-lg sm:text-xl ${isLightTheme ? 'text-[#6B6B6B]' : 'text-[#9B9B9B]'}`} data-id="element-23">
              {t('contact.availability')}
            </p>
          </div>

          <div className="space-y-10" data-id="element-24">
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-25">
              <a href="mailto:mick@mvlcreative.com" className={`flex items-center justify-center gap-3 px-8 py-4 rounded-xl font-medium transition-all shadow-sm flex-1 ${isLightTheme ? 'bg-white border border-black/[0.06] text-[#1A1A1A] hover:bg-black/5' : 'bg-[#1A1A1A] border border-white/[0.06] text-[#E8E8E6] hover:bg-white/5'}`} data-id="element-26">
                <Mail className="w-5 h-5" data-id="element-27" />
                mick@mvlcreative.com
              </a>
              <a href="https://calendly.com/mick-mvlcreative/30min" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 px-8 py-4 rounded-xl bg-[#C8956C] text-white font-medium hover:bg-[#B5825A] transition-all shadow-lg shadow-[#C8956C]/20 flex-1" data-id="element-28">
                <Calendar className="w-5 h-5" data-id="element-29" />
                {t('contact.cta_call')}
              </a>
            </div>

            <div className={`grid grid-cols-1 sm:grid-cols-2 gap-8 md:gap-12 pt-10 border-t ${isLightTheme ? 'border-black/[0.06]' : 'border-white/[0.06]'}`} data-id="element-30">
              <div className="space-y-3" data-id="element-31">
                <div className="font-mono text-xs uppercase tracking-widest text-[#C8956C]" data-id="element-32">
                  {t('contact.phone_label')}
                </div>
                <a href="tel:0651244475" className={`inline-block text-lg md:text-xl transition-all hover:text-[#C8956C] hover:underline underline-offset-4 ${isLightTheme ? 'text-[#1A1A1A]' : 'text-[#E8E8E6]'}`} data-id="element-33">
                  0651244475
                </a>
              </div>

              <div className="space-y-3" data-id="element-34">
                <div className="font-mono text-xs uppercase tracking-widest text-[#C8956C]" data-id="element-35">
                  {t('contact.social_label')}
                </div>
                <a href="https://linkedin.com/in/mick-van-latum" target="_blank" rel="noopener noreferrer" className={`inline-block text-lg md:text-xl transition-all hover:text-[#C8956C] hover:underline underline-offset-4 ${isLightTheme ? 'text-[#1A1A1A]' : 'text-[#E8E8E6]'}`} data-id="element-36">
                  LinkedIn ↗
                </a>
              </div>

              <div className="space-y-3" data-id="element-37">
                <div className="font-mono text-xs uppercase tracking-widest text-[#C8956C]" data-id="element-38">
                  {t('contact.location_label')}
                </div>
                <div className={`text-lg md:text-xl ${isLightTheme ? 'text-[#1A1A1A]' : 'text-[#E8E8E6]'}`} data-id="element-39">
                  {t('contact.location')}
                </div>
              </div>

              <div className="space-y-3" data-id="element-40">
                <div className="font-mono text-xs uppercase tracking-widest text-[#C8956C]" data-id="element-41">
                  {t('contact.status_label')}
                </div>
                <div className={`flex items-center gap-3 text-lg md:text-xl ${isLightTheme ? 'text-[#1A1A1A]' : 'text-[#E8E8E6]'}`} data-id="element-42">
                  <div className="w-2.5 h-2.5 rounded-full bg-[#27C93F] animate-pulse" data-id="element-43" />
                  {t('contact.status')}
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}